module.exports = __webpack_public_path__ + "img/needs_Improvement.6751ffbd.svg";